import { claimPwaInstallPoints } from '@/features/points/points-pwa-install-api';
import { isAuthError } from '@/shared/api/auth-failure';
import {
  hasOroMxPwaClaimedLocally,
  isOroMxStandalone,
  markOroMxPwaClaimedLocally,
} from '@/features/pwa/oro-mx-pwa-install';

export function bindOroMxPwaInstallReward(getAuth: () => { playerId?: string; simulation?: boolean; token?: string }): {
  tryClaim: () => void;
  unbind: () => void;
} {
  let pendingAppInstalled = false;
  const tryClaim = () => {
    const auth = getAuth();
    if (auth.simulation) return;
    const token = auth.token?.trim();
    const userId = auth.playerId?.trim() || 'anon';
    if (!token || hasOroMxPwaClaimedLocally(userId)) return;
    if (!isOroMxStandalone() && !pendingAppInstalled) return;
    void claimPwaInstallPoints(token)
      .then((result) => {
        if (result.applied) {
          markOroMxPwaClaimedLocally(userId);
        }
      })
      .catch((error: unknown) => {
        if (isAuthError(error)) return;
      });
  };

  const onInstalled = () => {
    pendingAppInstalled = true;
    tryClaim();
  };
  window.addEventListener('appinstalled', onInstalled);
  if (isOroMxStandalone()) {
    tryClaim();
  }
  return {
    tryClaim,
    unbind: () => {
      window.removeEventListener('appinstalled', onInstalled);
    },
  };
}
